module.exports = __webpack_public_path__ + "4a5760c1a0701e64213df6d668503ca4.svg";